module.exports = __webpack_public_path__ + "img/h-github.20f0424a.svg";